(function (global) {
  "use strict";

  const VERSION = "1";
  const DESIGN_ID_PATTERN = /^d_[0-9A-Za-z]{22}$/;
  const ACCENT_COUNT_PATTERN = /^(?:[1-9]|[1-9][0-9]|1[0-7][0-9]|18[0-4])$/;
  const ACCENT_VARIANT_ID = 44334622736611;
  const ACCENT_PENDING_KEY = "mossSimulatorAccentPendingV1";
  const ACCENT_PENDING_MAX_AGE_MS = 2 * 60 * 1000;
  const MAIN_LINE_STABILITY_DELAY_MS = 500;

  function readPendingAccent(storage, now = Date.now()) {
    if (!storage) return null;
    try {
      const value = JSON.parse(storage.getItem(ACCENT_PENDING_KEY) || "null");
      if (!value || !DESIGN_ID_PATTERN.test(value.designId || "") || !ACCENT_COUNT_PATTERN.test(String(value.accentCount || "")) || !Number.isInteger(value.baselineQuantity) || value.baselineQuantity < 0 || !Number.isFinite(value.createdAt) || now - value.createdAt > ACCENT_PENDING_MAX_AGE_MS) {
        storage.removeItem(ACCENT_PENDING_KEY);
        return null;
      }
      return value;
    } catch (error) {
      storage.removeItem(ACCENT_PENDING_KEY);
      return null;
    }
  }

  function cartQuantityForDesign(cart, designId) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce((sum, item) => {
      const properties = item && item.properties;
      return properties && properties["シミュレーターDesign ID"] === designId ? sum + Number(item.quantity || 0) : sum;
    }, 0);
  }

  function showError(doc, quantity) {
    const target = doc.querySelector("main, #MainContent") || doc.body;
    if (!target) return;
    let message = target.querySelector('[data-moss-sim-accent-error]');
    if (!message) {
      message = doc.createElement("p");
      message.setAttribute("data-moss-sim-accent-error", "");
      message.setAttribute("role", "alert");
      target.appendChild(message);
    }
    message.innerHTML = `アクセントタイルをカートに追加できませんでした。<a href="/products/mo-gold">追加購入ページから${quantity}枚追加してください。</a>`;
  }

  async function readCart(fetchImpl) {
    const response = await fetchImpl("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("cart-read-failed");
    return response.json();
  }

  async function processPendingAccent({
    doc,
    fetchImpl,
    storage,
    reload,
    now = Date.now(),
    waitImpl = (delay) => new Promise((resolve) => global.setTimeout(resolve, delay)),
  }) {
    const pending = readPendingAccent(storage, now);
    if (!pending) return { status: "idle" };
    const initialCart = await readCart(fetchImpl);
    const initialQuantity = cartQuantityForDesign(initialCart, pending.designId);
    if (initialQuantity <= pending.baselineQuantity) return { status: "waiting" };
    await waitImpl(MAIN_LINE_STABILITY_DELAY_MS);
    const stableCart = await readCart(fetchImpl);
    const stableQuantity = cartQuantityForDesign(stableCart, pending.designId);
    if (stableQuantity <= pending.baselineQuantity) return { status: "waiting" };
    const addResponse = await fetchImpl("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: ACCENT_VARIANT_ID, quantity: pending.accentCount }] }),
    });
    if (!addResponse.ok) throw new Error("accent-add-failed");
    storage.removeItem(ACCENT_PENDING_KEY);
    if (doc) doc.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
    if (typeof reload === "function") reload();
    return { status: "added", quantity: pending.accentCount };
  }

  function initialize(doc) {
    if (!doc || typeof global.fetch !== "function" || !global.sessionStorage) return false;
    if (global.__mossAccentCartProcessorVersion === VERSION) return false;
    global.__mossAccentCartProcessorVersion = VERSION;
    processPendingAccent({
      doc,
      fetchImpl: global.fetch.bind(global),
      storage: global.sessionStorage,
      reload: () => global.location.reload(),
    }).catch(() => {
      const pending = readPendingAccent(global.sessionStorage);
      if (pending) showError(doc, pending.accentCount);
    });
    return true;
  }

  const api = Object.freeze({
    ACCENT_PENDING_KEY,
    ACCENT_VARIANT_ID,
    MAIN_LINE_STABILITY_DELAY_MS,
    readPendingAccent,
    cartQuantityForDesign,
    processPendingAccent,
    initialize,
  });
  global.MoroccanSimulatorAccentCart = api;
  if (global.document) initialize(global.document);
})(typeof window !== "undefined" ? window : globalThis);
